<template>
  <div>
    <el-button
      size="small" type="primary" style="margin-top: 10px"
      @click="dialogVisible=true"
    >{{ $t('receivablePayable.ImportReceivableGeneration') }}</el-button>
    <el-dialog
      :title="$t('receivablePayable.ImportReceivableGeneration')"
      :visible.sync="dialogVisible"
      width="500px"
      append-to-body
      :before-close="handleClose"
    >
      <el-form
        ref="receivableForm"
        size="small"
        :model="receivableForm"
      >
        <el-form-item
          :label="$t('receivablePayable.SelectGenerateAccrualDate')"
          prop="timeCollection"
          :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
        >
          <el-date-picker
            v-model="receivableForm.timeCollection"
            :end-placeholder="$t('operationCenter.endDate')"
            :start-placeholder="$t('operationCenter.startDate')"
            range-separator="-"
            style="width: 100%"
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item
          :label="$t('receivablePayable.billType')"
          prop="statementType"
          :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
        >
          <el-select
            v-model="receivableForm.statementType"
            :placeholder="$t('operationCenter.PleaseSelect')"
            clearable
            size="small"
            filterable
            style="width: 100%;"
          >
            <el-option
              v-for="item in EXPRESS_TYPE"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div style="display: flex">
        <el-button
          size="small"
          style="margin-right: 10px"
          @click="downloadTemplate"
        >{{ $t('basicData.DownloadTheTemplate') }}</el-button>
        <!--        导入-->
        <upload-excel :but-name="$t('operationCenter.Import')" :on-success="importLogistics" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ExcelJs from 'exceljs';
import { saveAs } from 'file-saver';
import { siteBillImportGenerateBillNumber } from '@/api/finance/receivables';
import { CustomerPage } from '@/api/customer';
import { EXPRESS_TYPE } from '../utils';
import { goFileUploadManagement } from '@/utils/goExportList';
import { checkSameMonth } from '@/views/finance/utils';

export default {
  name: 'ImportReceivableGeneration',
  components: {
    UploadExcel: () => import('@/components/UploadExcel')
  },
  props: {
    // 费用类型
    feeTypeOptions: {
      type: Array,
      default: () => []
    },
    type: {
      type: Number,
      default: 1 // 2 整车
    }
  },
  data() {
    return {
      EXPRESS_TYPE,
      dialogVisible: false,
      receivableForm: {
        timeCollection: [], // 生成应收时间
        statementType: null // 账单类型
      },
      customerList: [] // 客户列表
    };
  },
  created() {
    // 获取客户选项
    const param = {
      pageNumber: 1,
      pageSize: 9999999,
      params: {}
    };
    CustomerPage(param).then((res) => {
      if (res.code === 200) {
        this.customerList = res.data.records;
      }
    });
  },
  methods: {
    /**
     * @description 弹窗关闭前的回调
     */
    handleClose() {
      this.dialogVisible = false;
      this.$refs.receivableForm.resetFields();
    },
    /**
     * @description 下载模板
     */
    downloadTemplate() {
      const that = this;
      const ddd = async() => {
        const wb = new ExcelJs.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        const Sheet2 = wb.addWorksheet('Sheet2');
        const Sheet3 = wb.addWorksheet('Sheet3');
        const Sheet4 = wb.addWorksheet('Sheet4');
        Sheet1.columns = [
          {
            header: this.$t('CenterForSorting.orderNum'), // 订单号
            key: '0',
            width: 40
          },
          {
            header: this.$t('receivablePayable.TicketNumber'), // 业务单号
            key: '1',
            width: 40
          },
          {
            header: this.$t('collectionCenter.businessT'), // 业务类型
            key: '2',
            width: 40
          },
          {
            header: this.$t('basicData.ExpenseType'), // 费用类型
            key: '3',
            width: 40
          },
          {
            header: this.$t('GlobalSetObj.client'), // 客户
            key: '4',
            width: 40
          }
        ];
        const Sheet1_data = [];
        Sheet1.addRows(Sheet1_data);
        // 业务类型添加下拉选项
        const businessType = [`${this.$t('collectionCenter.expressDelivery')}-0`, `${this.$t('collectionCenter.lanshou')}-1`, `${this.$t('collectionCenter.dispatch')}-2`];
        Sheet2.columns = [
          {
            header: this.$t('collectionCenter.businessT'), // 业务类型
            key: '0',
            width: 40
          }
        ];
        const Sheet2_data = businessType.map((item) => {
          return {
            0: item
          };
        });
        Sheet2.addRows(Sheet2_data);
        // 费用类型下拉选项
        const feeType = that.feeTypeOptions.map((item) => item.name + '-' + item.code);
        Sheet3.columns = [
          {
            header: this.$t('basicData.ExpenseType'), // 费用类型
            key: '0',
            width: 40
          }
        ];
        console.log(feeType);
        const Sheet3_data = feeType.map((item) => {
          return {
            0: item
          };
        });
        Sheet3.addRows(Sheet3_data);
        // 客户下拉选项
        const customer = that.customerList.map((item) => item.username + '-' + item.id);
        Sheet4.columns = [
          {
            header: this.$t('GlobalSetObj.client'), // 客户
            key: '0',
            width: 40
          }
        ];
        const Sheet4_data = customer.map((item) => {
          return {
            0: item
          };
        });
        Sheet4.addRows(Sheet4_data);
        // 为整个第三列设置数据验证
        const lastRow = Sheet1.rowCount > 1 ? Sheet1.rowCount : 300000; // 如果没有数据，默认设置100000行
        Sheet1.dataValidations.add(`C2:C${lastRow}`, {
          type: 'list',
          formulae: [`Sheet2!$A$2:$A$${businessType.length + 1}`]
        });
        Sheet1.dataValidations.add(`D2:D${lastRow}`, {
          type: 'list',
          formulae: [`Sheet3!$A$2:$A$${feeType.length + 1}`]
        });
        Sheet1.dataValidations.add(`E2:E${lastRow}`, {
          type: 'list',
          formulae: [`Sheet4!$A$2:$A$${customer.length + 1}`]
        });
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/octet-stream'
        });
        saveAs(blob, this.$t('receivablePayable.ImportReceivableTemplate') + '.xlsx');
      };
      ddd();
    },

    /**
     * 导入物流数据并进行字段映射
     * @param {Array} arr - 从 XLSX 文件导入的数据数组
     * @returns {Array} - 处理后的数据数组
     */
    importLogistics(arr) {
      console.log(arr);
      // 添加Loading
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let [nameStartTime, nameEndTime] = [null, null];
      this.$refs.receivableForm.validate((valid) => {
        if (!valid) {
          loading.close();
          return;
        }
        try {
          if (this.receivableForm.timeCollection && this.receivableForm.timeCollection.length > 0) {
            const flag = checkSameMonth(this.receivableForm.timeCollection);
            if (typeof flag !== 'boolean' || !flag) {
              this.$message.warning(this.$t('receivablePayable.dateRangeSameMonthValidation'));
              loading.close();
              return;
            }
            [nameStartTime, nameEndTime] = this.receivableForm.timeCollection;
          }

          // 校验输入数据结构
          if (!Array.isArray(arr) || !arr[0] || !arr[0].results) {
            throw new Error('Invalid input data structure');
          }

          const arrData = arr[0].results;
          if (!Array.isArray(arrData) || arrData.length === 0) {
            this.$message.warning(this.$t('userManage.ImportDataIsEmpty'));
            loading.close();
            return;
          }

          // 读取完整的表头
          const arrHeader = {};
          if (!Array.isArray(arr[0].header)) {
            throw new Error('Invalid header structure');
          }
          arr[0].header.forEach((item) => {
            arrHeader[item] = item;
          });

          // 映射关系
          const logisticsKey = {
            [this.$t('CenterForSorting.orderNum')]: 'orderNumber',
            [this.$t('receivablePayable.TicketNumber')]: 'waybillNumber',
            [this.$t('collectionCenter.businessT')]: 'businessType',
            [this.$t('basicData.ExpenseType')]: 'feeCode',
            [this.$t('GlobalSetObj.client')]: 'customerId'
          };
          // 提取正则表达式匹配逻辑
          const extractValue = (value, regex) => {
            const match = String(value).match(regex);
            return match ? match[1].trim() : value;
          };
          const data = arrData.map(row => {
            const processedRow = {};
            for (const key in arrHeader) {
              if (logisticsKey[key]) {
                let value = row[key] || '';

                // 特殊处理业务类型和费用类型
                if (key === this.$t('collectionCenter.businessT') || key === this.$t('basicData.ExpenseType')) {
                  value = extractValue(value, /.*?-(.*)/);
                }
                // 客户可能有多个-，只取最后一个-的后面的值
                if (key === this.$t('GlobalSetObj.client')) {
                  value = extractValue(value, /-(\d+)$/);
                }

                processedRow[logisticsKey[key]] = value;
              }
            }
            return processedRow;
          });
          // 数据量限制
          const MAX_DATA_LENGTH = 300000;
          if (data.length > MAX_DATA_LENGTH) {
            this.$message.error(this.$t('receivablePayable.ImportDataLimit'));
            loading.close();
            return;
          }

          siteBillImportGenerateBillNumber({
            importConditionList: data,
            nameStartTime,
            nameEndTime,
            statementType: this.receivableForm.statementType
          }).then(res => {
            if (res && res.code === 200) {
              goFileUploadManagement(this).then(flag => {
                if (flag) {
                  this.handleClose();
                }
              });
            } else {
              this.$message.error(this.$t('receivablePayable.ImportFailed'));
            }
          }).catch(() => {
            this.$message.error(this.$t('receivablePayable.ImportFailed'));
          }).finally(() => {
            loading.close();
          });
        } catch (error) {
          console.log(error);
          loading.close();
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
